import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { InstitutionsTab } from '../../components/RegulatoryWatchAdmin/InstitutionsTab';

export const AdminInstitutionsPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <InstitutionsTab />
    </FlexCol>
  );
};
